<template>
  <div 
    class="status-cards d-flex"
    data-testid="approval-status-cards"
  >
    <div
      v-if="pendingCountDisplay"
      :class="['status-card open', { active: activeFilter === 0 }]"
      data-testid="approval-status-cards__open"
      @click="$emit('filter', 0)"
    >
      <h6 class="label font-weight-medium">
        Open
        {{ $nova.labelsName('approvals_page', 'commentary_requests_label', 'Requests') }}
      </h6>
      <h3 class="count" v-if="dataStatusCount.open !== -1">
        {{ dataStatusCount.open }}
      </h3>
      <div v-else class="loading-spinner"></div>
    </div>

    <div
      v-if="inProgressCountDisplay"
      :class="['status-card in-progress', { active: activeFilter === 2 }]"
      data-testid="approval-status-cards__in-progress"
      @click="$emit('filter', 2)"
    >
      <h6 class="label font-weight-medium">
        {{ $nova.labelsName('approvals_page', 'commentary_inprogress_label', 'In Progress') }}
        <!-- {{ $nova.labelsName('approvals_page', 'commentary_requests_label', 'Requests') }} -->
      </h6>
      <h3 class="count" v-if="dataStatusCount.inProgress !== -1">
        {{ dataStatusCount.inProgress }}
      </h3>
      <div v-else class="loading-spinner"></div>
    </div>

    <div
      v-if="approvedCountDisplay"
      :class="['status-card approved', { active: activeFilter === 1 }]"
      data-testid="approval-status-cards__approved"
      @click="$emit('filter', 1)"
    >
      <h6 class="label font-weight-medium">
        {{ $nova.labelsName('approvals_page', 'commentary_approved_label', 'Approved') }}
        {{ $nova.labelsName('approvals_page', 'commentary_requests_label', 'Requests') }}
      </h6>
      <h3 class="count" v-if="dataStatusCount.approved !== -1">
        {{ dataStatusCount.approved }}
      </h3>
      <div v-else class="loading-spinner"></div>
    </div>

    <div
      v-if="rejectedCountDisplay"
      :class="['status-card rejected', { active: activeFilter === -1 }]"
      data-testid="approval-status-cards__rejected"
      @click="$emit('filter', -1)"
    >
      <h6 class="label font-weight-medium">
        {{ $nova.labelsName('approvals_page', 'commentary_rejected_label', 'Rejected') }}
        {{ $nova.labelsName('approvals_page', 'commentary_requests_label', 'Requests') }}
      </h6>
      <h3 class="count" v-if="dataStatusCount.rejected !== -1">
        {{ dataStatusCount.rejected }}
      </h3>
      <div v-else class="loading-spinner"></div>
    </div>

    <div
      v-if="failedCountDisplay"
      :class="['status-card failed', { active: activeFilter === 3 }]"
      data-testid="approval-status-cards__failed"
      @click="$emit('filter', 3)"
    >
      <h6 class="label font-weight-medium">
        {{ $nova.labelsName('approvals_page', 'commentary_failed_label', 'Failed') }}
        {{ $nova.labelsName('approvals_page', 'commentary_requests_label', 'Requests') }}
      </h6>
      <h3 class="count" v-if="dataStatusCount.retry !== -1">
        {{ dataStatusCount.retry }}
      </h3>
      <div v-else class="loading-spinner"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApprovalStatusCards',
  
  props: {
    activeFilter: {
      type: [Number, String],
      default: null
    },
    dataStatusCount: {
      type: Object,
      required: true,
      default: () => ({
        open: -1,
        approved: -1,
        rejected: -1,
        retry: -1,
        inProgress: -1
      })
    },
    pendingCountDisplay: {
      type: Boolean,
      default: true
    },
    approvedCountDisplay: {
      type: Boolean,
      default: true
    },
    rejectedCountDisplay: {
      type: Boolean,
      default: true
    },
    failedCountDisplay: {
      type: Boolean,
      default: true
    },
    inProgressCountDisplay: {
      type: Boolean,
      default: true
    }
  },

  beforeDestroy() {
    // Reset component state if needed
  }
}
</script>

<style scoped>
.status-cards {
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

.status-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  height: 44px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  /* background: #f7f7f7; */
  border: 1px solid;
  transition: all 0.2s ease;
  width: 200px;
  min-width: 200px;
  flex: 0 0 200px;
}

.status-card:hover {
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.status-card.active {
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
  z-index: 1;
}

.status-card .label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.status-card .count {
  font-weight: 600;
  margin: 0;
  flex-shrink: 0;
}

/* Loading Spinner */
.loading-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Individual colors - Original */
.status-card.open {
  border-color: #3b82f6;
  color: #4285F4;
  background: var(--blue-50, #F3F6FE);
}

.status-card.approved {
  border-color: #298159;
  color: #298159;
  background: var(--green-50, #F3F8F5);
}

.status-card.rejected {
  border-color: #E85B61;
  color: #E85B61;
  background: var(--red-50, #FDF4F4)
}

.status-card.failed {
  border-color: #AB4348;
  color: #AB4348;
  background: var(--red-50, #FDF4F4);
}

.status-card.in-progress {
  border-color: #EBA937;
  color: #EBA937;
  background: #FFF7EA;
}

/* ===========================================
   RESPONSIVE BREAKPOINTS
   =========================================== */

/* Small screens - allow cards to shrink slightly */
@media (max-width: 599px) {
  .status-cards {
    gap: 8px;
  }
  
  .status-card {
    width: 200px;
    min-width: 140px;
    flex: 1 1 auto;
  }
}

/* Extra small screens - full width */
@media (max-width: 400px) {
  .status-card {
    width: 100%;
    min-width: 100%;
    flex: 1 1 100%;
  }
}

/* Accessibility - Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .status-card {
    transition: none;
  }
  
  .loading-spinner {
    animation: none;
  }
}
</style>